import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import {H, Section } from "react-headings";

const Strings = require('../../../../app/shared/Strings');
import WithChannelData from '../DataHOCs/WithChannelData';
import WithActivityData from '../DataHOCs/WithActivityData';
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
import ActivityDetails from '../activity/ActivityDetails';
import ActivityStatsChartsChannel from './ActivityStatsChartsChannel';
import ChannelActivityOverviewRangeChart from './ChannelActivityOverviewRangeChart';
import ChannelActivityShareRangeChart from './ChannelActivityShareRangeChart';
import ChannelActivityAssignmentsTable from './ChannelActivityAssignmentsTable';
import ActivityCompletionStatsModal from '../modal/ActivityCompletionStatsModal';

const propTypes = {
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelStoreState: PropTypes.object.isRequired,
    activityStoreState: PropTypes.object.isRequired,
};

const defaultProps = {};

const DISABLE_ACT_EXPORT = !GlobalConfig.CanUseLargeExports;

class ActivityAnalyticsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAnalyticsModal: false,
        };

        this.toggleAnalyticsModal = this.toggleAnalyticsModal.bind(this);
    }

    toggleAnalyticsModal(showBool) {
        this.setState({ showAnalyticsModal: showBool });
    }

    render() {
        if (!this.props.activityStoreState.initialized) {
            return null;
        }

        const activity = this.props.activityStoreState.activity;
        if (!activity) {
            console.warn(`Activity ${this.props.activityId} not found in store.`);
            return null;
        }

        const channel = this.props.channelStoreState.channel;
        if (!channel) {
            console.warn(`Channel ${this.props.channelId} not found in store.`);
            return null;
        }

        let canExportActAnalytics = false;
        if (
            FeatureUtil.hasDetailedAnalytics(channel.channel_permissions)
            && PermissionsUtil.viewDetailedChannelAnalytics(channel.user_permissions)
        ) {
            canExportActAnalytics = true;
        }

        return (
            <div>
                <Section component={
                    <div>
                        <H className="large-heading fl">
                            {activity.meta_data.title}
                        </H>
                        {(canExportActAnalytics && !DISABLE_ACT_EXPORT) &&
                            <Button
                                className="fr margin-right-md"
                                disabled={!!this.state.toggleAnalyticsModalActionId}
                                onClick={this.toggleAnalyticsModal.bind(this, true)}
                                title={Strings['en'].analytics.overview.completion_act_stats_export.HEADING}
                            >
                                {Strings['en'].analytics.overview.completion_act_stats_export.HEADING}
                            </Button>
                        }
                    </div>
                }>
                <div className="float-clear margin-bottom-lg" />
                <Section component={
                    <H className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.activity_details.SECTION_HEADING}</H>
                }>
                    <ActivityDetails
                        {...this.props}
                        hideLoadingIcon
                        className="margin-bottom-xl"
                    />
                </Section>
                <Section component={
                    <H className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.playthrough_stats.SECTION_HEADING}</H>
                }>
                    <ActivityStatsChartsChannel {...this.props} />
                </Section>
                <Section component={
                    <H className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.assignment_stats.SECTION_HEADING}</H>
                }>
                    <ChannelActivityOverviewRangeChart {...this.props} />
                </Section>
                <Section component={
                    <H className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.share_stats.SECTION_HEADING}</H>
                }>
                    <ChannelActivityShareRangeChart {...this.props} />
                </Section>
                <Section component={
                    <H className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.assignment_table.SECTION_HEADING}</H>
                }>
                    <ChannelActivityAssignmentsTable {...this.props} />
                    {(this.state.showAnalyticsModal) && 
                        <ActivityCompletionStatsModal
                            channelId={this.props.channelId}
                            projectId={this.props.projectId}
                            activityId={this.props.activityId}
                            onClose={this.toggleAnalyticsModal.bind(this, false)}
                        />
                    }
                  </Section>
              </Section>
            </div>
        );
    }
}

ActivityAnalyticsView.propTypes = propTypes;
ActivityAnalyticsView.defaultProps = defaultProps;

export default WithChannelData(WithActivityData(ActivityAnalyticsView));